import React from 'react';
import {_GPY,__GPYGet} from '../../env.js'
import ServerPing from './ServerPing.js';


class Navigation extends React.Component {

	constructor(props) {
	    super(props);
	    this.state = {
				locales: {},
				localesIsLoaded : false,
				language: [],
	    };
	}

	componentDidMount(){
		__GPYGet("getAllowedLanguages",(result) => {
				this.setState({language: result});
			}
			, (error) => {
				this.setState({language:[]});
			}
		);
	}

	setGameType(f){
     this.props.setGameType(f);
	}

	setGameMenuInView(f){
		console.log("setGameMenuInView",f);
     this.props.setGameMenuInView(f);
	}

	onLogout(e) {
		   e.preventDefault();
			 __GPYGet('doLogout',(res) => {
				 	console.log(res.Result.state) ;
					 if(res.Result.state === "OK"){
						 	this.props.guppyi.loadUIStates();
					 }
			 });
	 }

	 goFullScreen(){
		 this.props.scoreboard.setState({isFull:!this.props.scoreboard.state.isFull});
	 }

   render () {
/*
	 	var obs = function(t) {
			 if(t) {
				 return (<span className="glyphicon glyphicon-expand"></span>);
			 } else {
				 return (<span className="glyphicon glyphicon-unchecked"></span>);
			 }
		 };
*/
		 return (
			<nav className={this.props.scoreboard.state.isFull?"navbar navbar-expand-lg navbar-light bg-light pt-0 pb-0":"navbar navbar-expand-lg navbar-light bg-light"} style={{zIndex:100}}>
    		<div className="navbar-brand">
					<a href="https://www.guppyi.com/"><img style={{maxHeight : '25px'}} src={_GPY.resource("images/fav.png")} className="img-fluid mx-auto" alt="Guppyi"/></a>
{_GPY.uiStates.userLvl < _GPY.USER_PRO ?
					<button onClick={this.setGameType.bind(this,"UserSubscription")} className="btn btn-link p-0 pl-1"><img style={{maxHeight : '25px'}} src={_GPY.resource("images/gopro.gif")} className="img-fluid" alt="Guppyi"/></button>
:
					<img style={{maxHeight : '25px'}} src={_GPY.resource("images/pro.png")} className="img-fluid pl-1" alt="Guppyi"/>
}
				</div>

				<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    			<span className="navbar-toggler-icon"></span>
  			</button>


				<div className="collapse navbar-collapse" id="navbarSupportedContent">
{!this.props.scoreboard.state.isFull?
    		<ul className="nav nav-pill mr-auto">
				   	{this.props.menuLinks.MenuItems.MenuItem.map((item) => {
								if(item.type === 'LINK') {
									if(item.icon !== '') {
										var icon = "glyphicon glyphicon-"+item.icon;
										return( <li key={item.link} onClick={()=>{this.setGameMenuInView(item.link)}} className="nav-item"><button className="btn btn-link nav-link pr-1"><span className={icon}></span>&nbsp;{item.title}</button></li>);
									} else {
										return( <li key={item.link} onClick={()=>{this.setGameMenuInView(item.link)}} className="nav-item"><button className="btn btn-link nav-link pr-1">{item.title}</button></li>);
									}
								}
								return (<div/>);
							}
						 )
						}
			  </ul>
:<ul className="nav nav-pill mr-auto"/>}


{!this.props.scoreboard.state.isFull?

				<ul className="nav nav-pill navbar-right">

						<li className="nav-item">
						<button onClick={()=>{this.setGameType("Dashboard")}} className="btn btn-link"><span className="glyphicon glyphicon-th" aria-hidden="true"></span></button>
{/*
							<a className="nav-link" href="#" onClick={this.toggleOBSPanel.bind(this)}>{obs(this.props.scoreboard.state.showOBSPanel)} OBS</a>
*/}
						</li>




						<li className="nav-item dropdown">
						<button className="btn btn-link nav-link dropdown-toggle pl-0 pr-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span className="glyphicon glyphicon-blackboard Scoreboard"></span></button>
							<div className="dropdown-menu">

														 {this.props.gameTypes.MenuItems.MenuItem.map((item) => {
																	if(item.link  === this.props.gameType) {
																			return( <span key={item.link} className="dropdown-item text-primary"><strong>{item.title}</strong></span> );
																	} else {
																		return( <button key={item.link} onClick={()=>{this.setGameType(item.link)}} className="btn btn-link dropdown-item">{item.title}</button> );
																	}
															})
														 }

							</div>
						</li>



						<li className="nav-item dropdown">

						<button className="btn btn-link nav-link dropdown-toggle pl-0 pr-1" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"><img className="img-fluid pb-1" alt={"flag "+_GPY.locale} src={_GPY.resource("images/flags/"+_GPY.locale+".png")}/></button>
    		      <div className="dropdown-menu">
														 {this.state.language.map((item) => {
															    return (<button key={item.Locale.localeString} className="btn btn-link dropdown-item" onClick={()=>{_GPY.setLanguage(item.Locale.localeString);}}><img alt={item.Locale.displayLang} src={_GPY.resource("images/flags/"+item.Locale.localeString+".png")}/> {item.Locale.displayLang}</button>)
														 	})
														}
    		      </div>
    		    </li>


						<li className="nav-item dropdown">
    		      <button className="btn btn-link nav-link dropdown-toggle pl-0 pr-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							{_GPY.uiStates.userImg !== undefined?
								<img style={{maxWidth : '25px', maxHeight : '25px'}} src={_GPY.resource("upload/"+_GPY.uiStates.userImg)} className="img-fluid rounded" alt=""/>
								:
								<span className="glyphicon glyphicon-user"></span>
							}
							&nbsp;{_GPY.uiStates.userName}</button>
    		      <div className="dropdown-menu">
									{/*
									<a key="user_account" onClick={this.onLogout.bind(this)} className="dropdown-item" href="#">{_GPY.i18n.get('navigation_link_account')}</a>
									<a key="user_bills" onClick={this.onLogout.bind(this)} className="dropdown-item" href="#">{_GPY.i18n.get('navigation_link_bills')}</a>
									<div className="dropdown-divider"></div>
									*/}

{_GPY.standaloneMode?"":
<div>
									<button key="UserAccount" onClick={this.setGameType.bind(this,"UserAccount")} className="btn btn-link dropdown-item">{_GPY.i18n.get('navigation_link_user_account')}</button>
									<button key="UserSubscription" onClick={this.setGameType.bind(this,"UserSubscription")} className="btn btn-link dropdown-item">{_GPY.i18n.get('navigation_link_user_subscription')}</button>
									<button key="UserBills" onClick={this.setGameType.bind(this,"UserBills")} className="btn btn-link dropdown-item">{_GPY.i18n.get('navigation_link_user_bills')}</button>

									<div className="dropdown-divider"></div>
										<button key="Fonts" onClick={this.setGameType.bind(this,"Fonts")} className="btn btn-link dropdown-item">{_GPY.i18n.get('navigation_link_fonts')}</button>
									<div className="dropdown-divider"></div>
</div>
}
									<button key="UserAdvertisement" onClick={this.setGameType.bind(this,"UserAdvertisement")} className="btn btn-link dropdown-item">{_GPY.i18n.get('navigation_link_user_advertisement')}</button>
									<button key="UserAdvertisementSponsor" onClick={this.setGameType.bind(this,"UserAdvertisementSponsor")} className="btn btn-link dropdown-item">{_GPY.i18n.get('navigation_link_user_sponsor')}</button>

									<div className="dropdown-divider"></div>
									<button key="BugReport" onClick={this.setGameType.bind(this,"BugReport")} className="btn btn-link dropdown-item">BugReport</button>

{_GPY.standaloneMode?"":
<div>
									<div className="dropdown-divider"></div>
									<button key="user_logout" onClick={this.onLogout.bind(this)} className="btn btn-link dropdown-item">{_GPY.i18n.get('navigation_link_logout')}</button>
</div>
}

									<div className="dropdown-divider"></div>

{_GPY.uiStates.userLvl >= _GPY.USER_EXPERT ?
						<div style={{backgroundColor: "#ffaaaa"}} >
									<button key="adminRemember2Confirm" onClick={()=>{__GPYGet("adminRemember2Confirm");}} className="btn btn-link dropdown-item">eMailRemember2Confirm</button>
						</div>
:""}

								<div className="dropdown-divider"></div>

{_GPY.uiStates.userLvl >= _GPY.USER_TRANSLATOR ?
						<div style={{backgroundColor: "#ffffaa"}} >
									<button key="reloadI18n" onClick={()=>{__GPYGet("reloadI18n",()=>{alert('Reloaded')});}} className="btn btn-link dropdown-item">Reload translations</button>
									<a key="editI18n" href={window.location.href.replace('#','')+"?i18n=true"} className="dropdown-item">Edit translation</a>
									<button key="UnknownI18nKeys" onClick={this.setGameType.bind(this,"UnknownI18nKeys")} className="btn btn-link dropdown-item">UnknownI18nKeys</button>

									<button key="RestTimers" onClick={()=>{__GPYGet("resetTimers",()=>{alert('restTimers done')});}} className="btn btn-link dropdown-item">resetTimers</button>
						</div>
:""}

							</div>
    		    </li>


					 <li className="nav-item"><button className="btn btn-link nav-link  pl-1 pr-1" onClick={this.goFullScreen.bind(this)}><span className={this.props.scoreboard.state.isFull?"glyphicon glyphicon-resize-small":"glyphicon glyphicon-fullscreen"}></span></button></li>
					 <li className="nav-item"><span className="navbar-text pl-0 pr-1"><ServerPing/></span></li>
			</ul>
:
			<ul className="nav nav-pill navbar-right">
			  <li className="nav-item"><button onClick={this.setGameType.bind(this,"Dashboard")} className="btn btn-link"><span class="glyphicon glyphicon-th" aria-hidden="true"></span></button></li>
				<li className="nav-item"><button className="btn btn-link nav-link" onClick={this.goFullScreen.bind(this)}><span className={this.props.scoreboard.state.isFull?"glyphicon glyphicon-resize-small":"glyphicon glyphicon-fullscreen"}></span></button></li>
				<li className="nav-item"><span className="navbar-text"><ServerPing/></span></li>
			</ul>
}
				 </div>
    		</nav>
	   	)
  }
}
export default Navigation;
